import type { PropsWithChildren } from 'react';

type PlaylistVarsScopeProps = PropsWithChildren;

/**
 * Scopes global playlist CSS variables to playlist-rendering UI trees.
 */
export function PlaylistVarsScope({
  children,
}: PlaylistVarsScopeProps): JSX.Element {
  return <div className="playlist-vars">{children}</div>;
}
